const BASE58_ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
const ED25519_MULTICODEC_PREFIX = Uint8Array.of(0xed, 0x01);
export function deriveDeviceIdentifiers(publicKey) {
    if (publicKey.byteLength !== 32) {
        throw new Error("Invalid Ed25519 public key");
    }
    const publicKeyMultibase = `z${base58Btc(publicKey)}`;
    const didKeyMaterial = new Uint8Array(ED25519_MULTICODEC_PREFIX.byteLength + publicKey.byteLength);
    didKeyMaterial.set(ED25519_MULTICODEC_PREFIX);
    didKeyMaterial.set(publicKey, ED25519_MULTICODEC_PREFIX.byteLength);
    return {
        did: `did:key:z${base58Btc(didKeyMaterial)}`,
        nodeId: [...publicKey].map((byte) => byte.toString(16).padStart(2, "0")).join(""),
        publicKeyMultibase,
    };
}
function base58Btc(bytes) {
    if (bytes.byteLength === 0)
        return "";
    let leadingZeros = 0;
    while (leadingZeros < bytes.byteLength && bytes[leadingZeros] === 0) {
        leadingZeros += 1;
    }
    if (leadingZeros === bytes.byteLength)
        return "1".repeat(leadingZeros);
    const digits = [0];
    for (const byte of bytes.slice(leadingZeros)) {
        let carry = byte;
        for (let index = 0; index < digits.length; index += 1) {
            const value = (digits[index] ?? 0) * 256 + carry;
            digits[index] = value % 58;
            carry = Math.floor(value / 58);
        }
        while (carry > 0) {
            digits.push(carry % 58);
            carry = Math.floor(carry / 58);
        }
    }
    let encoded = "1".repeat(leadingZeros);
    for (let index = digits.length - 1; index >= 0; index -= 1) {
        encoded += BASE58_ALPHABET[digits[index] ?? 0];
    }
    return encoded;
}
//# sourceMappingURL=did.js.map